import type {PropsWithChildren} from "react";
import cn from "classnames";

import {capitalize} from "@pg-mono/nodash";

import {TabsActiveColor} from "../types/TabsActiveColor";
import {TabsTheme} from "../types/TabsTheme";
import {TabsVariant} from "../types/TabsVariant";
import {colorToClassName} from "../utils/color_to_class_name";

import * as styles from "./Title.module.css";

interface IProps {
    activeColor?: TabsActiveColor;
    active: boolean;
    className?: string;
    fullWidth?: boolean;
    gtmClick?: string;
    onClick: () => void;
    theme: TabsTheme;
    variant: TabsVariant;
}

type ClassName = keyof typeof styles;

const getTitleTheme = (theme: TabsTheme) => `title${capitalize(theme)}` as ClassName;
const getTitleActiveColor = (color: TabsActiveColor) => `titleActiveColor${colorToClassName(color)}` as ClassName;

export const Title = (props: PropsWithChildren<IProps>) => {
    const isLineVariant = props.variant === "line";

    const classes = cn(
        styles.title,
        styles[getTitleTheme(props.theme)],
        {
            [styles.active]: props.active,
            [styles.line]: isLineVariant,
            [styles.wFull]: props.fullWidth
        },
        props.activeColor && styles[getTitleActiveColor(props.activeColor)],
        props.className
    );

    return (
        <div className={classes} data-gtm-click={props.gtmClick} data-name="tab-title" onClick={props.onClick}>
            {props.children}
        </div>
    );
};
import type {PropsWithChildren} from "react";
import cn from "classnames";

import {capitalize} from "@pg-mono/nodash";

import {TabsActiveColor} from "../types/TabsActiveColor";
import {TabsTheme} from "../types/TabsTheme";
import {TabsVariant} from "../types/TabsVariant";
import {colorToClassName} from "../utils/color_to_class_name";

import * as styles from "./Title.module.css";

interface IProps {
    activeColor?: TabsActiveColor;
    active: boolean;
    className?: string;
    fullWidth?: boolean;
    gtmClick?: string;
    onClick: () => void;
    theme: TabsTheme;
    variant: TabsVariant;
}

type ClassName = keyof typeof styles;

const getTitleTheme = (theme: TabsTheme) => `title${capitalize(theme)}` as ClassName;
const getTitleActiveColor = (color: TabsActiveColor) => `titleActiveColor${colorToClassName(color)}` as ClassName;

export const Title = (props: PropsWithChildren<IProps>) => {
    const isLineVariant = props.variant === "line";

    const classes = cn(
        styles.title,
        styles[getTitleTheme(props.theme)],
        {
            [styles.active]: props.active,
            [styles.line]: isLineVariant,
            [styles.wFull]: props.fullWidth
        },
        props.activeColor && styles[getTitleActiveColor(props.activeColor)],
        props.className
    );

    return (
        <div className={classes} data-gtm-click={props.gtmClick} data-name="tab-title" onClick={props.onClick}>
            {props.children}
        </div>
    );
};
